import { camelCaseToTitleCase } from 'components/account/jobs-v2/dropdowns/utils';
export const getRequestItemEntries = (request) => Object.entries(request).flatMap(([key, value]) => key !== 'callbackUrl' && key !== 'associatedJobId'
    ? [{ label: camelCaseToTitleCase(key), value }]
    : []);
export const AML_BORDER_COLOR = '#C6C6CA';
